// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Inicio from './pages/Inicio';
import Inventario from './pages/Inventario';
import Servicios from './pages/Servicios1';
import Clientes from './pages/Clientes1';
import ClienteDetalle from './pages/ClienteDetalle';
import Venta from './pages/Venta';
import HistorialInventario from './pages/HistorialInventario';
import HistorialVentas from './pages/HistorialVentas';
import Reportes from './pages/ReportesMejorado';
import Facturas from './pages/Facturas';
import Devoluciones from './pages/Devoluciones';
import ProtectedRoute from './components/ProtectedRoute';
import { useUser } from './context/UserContext';
import Retenciones from './pages/Retenciones';
import FacturasPorCobrar from './pages/FacturasPorCobrar';
import Pedidos from './pages/Pedidos';            
import RegistroPagos from './pages/RegistroPagos';   // 👈 IMPORTANTE: agrega esta línea

const AppContent = () => {
  const location = useLocation();
  const { usuario, rol, cargando } = useUser();

  const sinSidebar = location.pathname === '/login' || location.pathname === '/registro';

  if (cargando) return <p style={{ color: 'white', padding: 20 }}>Cargando...</p>;

  return (
    <div className="app-container">
      {!sinSidebar && usuario && <Sidebar />}
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />

          <Route
            path="/"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor', 'deposito', 'mecanico']}>
                <Inicio />
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventario"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor', 'deposito']}>
                <Inventario />
              </ProtectedRoute>
            }
          />

          <Route
            path="/retenciones"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2']}>
                <Retenciones />
              </ProtectedRoute>
            }
          />

          <Route
            path="/servicios"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor', 'mecanico']}>
                <Servicios />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clientes"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor']}>
                <Clientes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clientes/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor']}>
                <ClienteDetalle />
              </ProtectedRoute>
            }
          />

          <Route
            path="/venta"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor', 'deposito']}>
                <Venta />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pedidos"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor']}>
                <Pedidos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/historial-inventario"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <HistorialInventario />
              </ProtectedRoute>
            }
          />

          <Route
            path="/historial-ventas"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2']}>
                <HistorialVentas />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reporte"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2']}>
                <Reportes />
              </ProtectedRoute>
            }
          />

          {/* NUEVA RUTA: Registro de Pagos */}
          <Route
            path="/registro-pagos"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2']}>
                <RegistroPagos />
              </ProtectedRoute>
            }
          />

          {/* Facturas por pagar */}
          <Route
            path="/facturas"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2']}>
                <Facturas />
              </ProtectedRoute>
            }
          />

          {/* Facturas por cobrar */}
          <Route
            path="/facturas-por-cobrar"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor']}>
                <FacturasPorCobrar />
              </ProtectedRoute>
            }
          />

          <Route
            path="/devoluciones"
            element={
              <ProtectedRoute allowedRoles={['admin', 'admin2', 'vendedor']}>
                <Devoluciones />
              </ProtectedRoute>
            }
          />

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
